import axios from 'axios'
import store from '@/store'
import { getToken } from './util'
import { Message } from 'view-design'
import router from '../router'
// import { Spin } from 'view-design'
// const addErrorLog = (errorInfo) => {
//   const {
//     statusText,
//     status,
//     request: { responseURL }
//   } = errorInfo
//   let info = {
//     type: 'ajax',
//     code: status,
//     mes: statusText,
//     url: responseURL
//   }
//   if (!responseURL.includes('save_error_logger')) {
//     store.dispatch('addErrorLog', info)
//   }
// }

let flag = 0

class HttpRequest {
  constructor(baseUrl = baseURL) {
    this.baseUrl = baseUrl
    this.queue = {}
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
      headers: {
        //
      }
    }
    return config
  }
  destroy(url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }
  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        // 添加全局的loading...
        if (!Object.keys(this.queue).length) {
          // Spin.show() // 不建议开启，因为界面不友好
        }
        this.queue[url] = true
        if (!config.noToken) {
          config.headers['token'] = getToken()
        }
        config.headers['lang'] = 'zh_HK'
        config.headers['applicationId'] = 1
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        this.destroy(url)
        const { data } = res

        if (res.config.skipIntercept) return res
        if (data.code === 200) { return data } else {
          if(data.message){
            const msg = data.message.split('\n')
            Message.error({
              render:h =>
                h('span', {}, msg.map(el => h('div', el))),
              duration: 3

            })
          }
          return Promise.reject(data)
        }
      },
      (error) => {
        this.destroy(url)
        let errorInfo = error.response
        const { status } = errorInfo
        if (!errorInfo) {
          const {
            request: { statusText, status },
            config
          } = JSON.parse(JSON.stringify(error))
          errorInfo = {
            statusText,
            status,
            request: { responseURL: config.url }
          }
        }

        if (status === 403||status === 401) {
          if(flag) return 
          Message.error('登录状态过期，请重新登录')
          flag = 1
          store.dispatch('handleLogOut').then(r => {
            router.replace({
              name:'login'
            }).then(()=>{
              router.go(0)
              flag = 0
            })
          })
        }
        // addErrorLog(errorInfo)
        return Promise.reject(error)
      }
    )
  }
  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
